import React, { useState } from 'react';
import {
  View,
  Image,
  TouchableOpacity,
  Dimensions,
  useColorScheme,
  ActivityIndicator,
  StatusBar,
  Platform,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { useRouter, useLocalSearchParams } from 'expo-router';
import { Ionicons } from '@expo/vector-icons';

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = Dimensions.get('window');

/**
 * Full-screen image viewer for chat images
 */
export default function ImageViewerScreen() {
  const colorScheme = useColorScheme();
  const router = useRouter();
  const { url } = useLocalSearchParams<{ url: string }>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const decodedUrl = url ? decodeURIComponent(url) : '';

  const handleClose = () => {
    router.back();
  };

  if (!decodedUrl) {
    return (
      <SafeAreaView className="flex-1 bg-black items-center justify-center">
        <Ionicons name="image-outline" size={64} color="#6B7280" />
      </SafeAreaView>
    );
  }

  return (
    <View className="flex-1 bg-black">
      <StatusBar barStyle="light-content" />
      
      {/* Close button */}
      <SafeAreaView
        edges={['top']}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
        }}
      >
        <View className="flex-row justify-between items-center px-4 py-3">
          <TouchableOpacity
            onPress={handleClose}
            className="w-10 h-10 bg-black/50 rounded-full items-center justify-center"
            activeOpacity={0.7}
            accessibilityLabel="Sluiten"
            accessibilityRole="button"
          >
            <Ionicons name="close" size={24} color="#fff" />
          </TouchableOpacity>
        </View>
      </SafeAreaView>

      {/* Image */}
      <View className="flex-1 items-center justify-center">
        {loading && (
          <View className="absolute inset-0 items-center justify-center">
            <ActivityIndicator size="large" color="#fff" />
          </View>
        )}
        
        {error ? (
          <View className="items-center justify-center">
            <Ionicons name="image-outline" size={64} color="#6B7280" />
          </View>
        ) : (
          <Image
            source={{ uri: decodedUrl }}
            style={{
              width: SCREEN_WIDTH,
              height: SCREEN_HEIGHT,
            }}
            resizeMode="contain"
            onLoadStart={() => setLoading(true)}
            onLoadEnd={() => setLoading(false)}
            onError={() => {
              setLoading(false);
              setError(true);
            }}
          />
        )}
      </View>
    </View>
  );
}

